<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 800px; height: 800px;" data-cy="case-view-patient-forms-details">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="case-view-patient-forms-details-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="case-view-patient-forms-details-header">
      <div class="section-header-title" data-cy="case-view-patient-forms-details-title">
        Patient Forms Info
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; overflow-y: auto;" data-cy="case-view-patient-forms-details-content">
      <div *ngFor="let form of forms" style="display: flex; flex-direction: column; border-style: solid; border-color: var(--tdo-subnav-color); border-radius: var(--border-radius); margin-bottom: 12px;" data-cy="case-view-patient-forms-details-form-item">
        <div style="display: flex;" data-cy="case-view-patient-forms-details-form-name-row">
          <div class="label-column" data-cy="case-view-patient-forms-details-form-name-label">Form Name:</div>
          <div style="flex: 1;" data-cy="case-view-patient-forms-details-form-name-value">{{form.Description}}</div>
        </div>
        <div style="display: flex;" data-cy="case-view-patient-forms-details-form-version-row">
          <div class="label-column" data-cy="case-view-patient-forms-details-form-version-label">Form Version:</div>
          <div style="flex: 1;" data-cy="case-view-patient-forms-details-form-version-value">{{form.Versions[0].Version.toString()}}</div>
        </div>
        <div style="display: flex; margin-top: 14px;" data-cy="case-view-patient-forms-details-status-row">
          <div class="label-column" data-cy="case-view-patient-forms-details-status-label">Status:</div>
          <div style="flex: 1;" data-cy="case-view-patient-forms-details-status-value">{{form.Status}}</div>
        </div>
        <div style="display: flex;" data-cy="case-view-patient-forms-details-status-on-row">
          <div class="label-column" data-cy="case-view-patient-forms-details-status-on-label">On:</div>
          <div style="flex: 1;" data-cy="case-view-patient-forms-details-status-on-value">{{form.StatusOn ? (form.StatusOn + 'Z' | date: 'short') : ''}}</div>
        </div>
        <div style="display: flex;" data-cy="case-view-patient-forms-details-status-by-row">
          <div class="label-column" data-cy="case-view-patient-forms-details-status-by-label">By:</div>
          <div style="flex: 1;" data-cy="case-view-patient-forms-details-status-by-value">{{getUserName(form.StatusBy)}}</div>
        </div>
        <div style="display: flex;" data-cy="case-view-patient-forms-details-signature-row">
          <div class="label-column" data-cy="case-view-patient-forms-details-signature-label">Need Signature:</div>
          <div style="flex: 1;" data-cy="case-view-patient-forms-details-signature-value">{{form.isRequireSignature ? 'Yes' : 'No'}}</div>
        </div>
        <div style="display: flex;" data-cy="case-view-patient-forms-details-signed-on-row">
          <div class="label-column" data-cy="case-view-patient-forms-details-signed-on-label">Signed On:</div>
          <div style="flex: 1;" data-cy="case-view-patient-forms-details-signed-on-value">{{ form.SignedOn ? (form.SignedOn + 'Z' | date: 'short') : '' }}</div>
        </div>
        <div style="display: flex;" data-cy="case-view-patient-forms-details-signed-by-row">
          <div class="label-column" data-cy="case-view-patient-forms-details-signed-by-label">Signed By:</div>
          <div style="flex: 1;" data-cy="case-view-patient-forms-details-signed-by-value">{{getUserName(form.SignedBy)}}</div>
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="case-view-patient-forms-details-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="case-view-patient-forms-details-ok-btn">Ok</button>
    </div>
  </div>
</div>
